import { GroupType } from '../types/others';

export const getInitials = (data: { name?: string | null }): string | undefined => {
  let result = '';
  if (data?.name && data.name.length > 0) {
    const splitName = data?.name?.split(' ');
    for (let index = 0; index < 2; index++) {
      if (splitName?.[index] && splitName?.[index]?.length > 0) {
        result += splitName[index][0];
      }
    }
  }
  return result.length > 0 ? result : undefined;
};

export const getAuthorUploadFileName = () => {
  const prefix = 'in';
  const randomString = Math.random().toString(36).substring(2, 10);
  return prefix?.concat('-', randomString);
};
